import React from "react";
import CommunityListPage from "../community/components/CommunityListPage";
import { SHARE_WITH_NEIGHBORS } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function ShareWithNeighborsPage() {
  useRequireSectionVisible("showShareWithNeighbors");
  return <CommunityListPage section={SHARE_WITH_NEIGHBORS} />;
}
